import { Typography } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AbsenceStatus } from '~/data/absences';

import { useSxStyles } from './useStyles';

type PropsType = {
  status: AbsenceStatus;
};

export const AbsenceStatusLabel = (props: PropsType) => {
  const { status } = props;
  const sxStyles = useSxStyles();

  const { t } = useTranslation();

  const statusSx = useMemo(() => {
    switch (status) {
      case AbsenceStatus.APPROVED:
        return sxStyles.statusApproved;
      case AbsenceStatus.PROPOSED:
        return sxStyles.statusProposed;
      case AbsenceStatus.REJECTED:
        return sxStyles.statusRejected;
      default:
        return {};
    }
  }, [status, sxStyles]);

  return (
    <Typography
      sx={{
        ...sxStyles.status,
        ...statusSx,
      }}
    >
      {t(status.toLowerCase())}
    </Typography>
  );
};
